// @flow
import ConnectAdapter from './ConnectAdapter';
import TokenManager from './TokenManager';

export interface ContextItemBeingDisplayed {
    kind: 'issue' | 'external';
    itemType?: string;
    keyOrId: string;
    projectId?: string;
}

export interface LicenseDetails {
    active: boolean;
    billingPeriod: string;
    ccpEntitlementId: string;
    ccpEntitlementSlug: string;
    isEvaluation: boolean;
    subscriptionEndDate: string | null;
    supportEntitlementNumber: string | null;
    trialEndDate: string | null;
    type: string;
    modes?: any;
}

export interface PlatformAdapter {
    getToken(): Promise<string>;
    getCurrentUrl(): Promise<string>;
    requestJira(path: string, options?: any): Promise<any>;
    invokeRemote(method: string, path: string, args?: any): Promise<any>;
    initializeTheming(): Promise<void>;
    openIssueDialog(issueKey: string, onClose?: (issueKeyOrErr: string) => void): any;
    isForge(): boolean;
    getRouteParams(): Promise<URLSearchParams>;
    updateRouteParams(params: URLSearchParams): void;
    getJiraContext(): any;
    resizeWindow(width: string, height: string): any;
    getLocationFromCurrentModuleKey(): Promise<string>;
    openNewTab(path: string): void;
    isGlobalContext: () => Promise<boolean>;
    refreshJiraIssuePage: () => void;
    navigateHomePage: () => void;
    getProjectUrl: (projectKey: string, projectStyle: 'classic' | string, params?: string) => string;
    openProjectUrl: (projectKey: string, projectStyle: 'classic' | string, params?: string) => void;
}

export const createPlatformAdapter = async (): Promise<PlatformAdapter> => {
    let adapter: PlatformAdapter;
    if (!window || window?.AP) {
        adapter = new ConnectAdapter();
    } else {
        const ForgeAdapter = await import('./ForgeAdapter');
        adapter = await ForgeAdapter.default();
    }
    const tokenManager = new TokenManager(adapter);
    await Promise.all([tokenManager.initializeToken(), adapter.initializeTheming()]);
    return adapter;
};
